import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Blog from "./Blog/index";
import Calendar from "./Calendar/index";
import Marquee from "../../components/marquee";
import Highlights from "./Highlights";

class Home extends Component {
    render() {
        const { homeData } = this.props;

        if (!homeData) return <div className="h-screen" />;

        return (
            <div>
                <Marquee backgroundColor={"bg-pink"} color={"blue"} />
                {homeData.content && homeData.content.length > 0 ? (
                    <Highlights
                        title={homeData.subtitle}
                        highlights={homeData.content}
                    />
                ) : (
                    <Blog />
                )}
                <Calendar />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    homeData: state.pages.homepage,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
